
export default {
  name: "Cal-heading-para-section",
  props: ["paraContent", "headingContent"],
};
